import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Recommend from 'pages/recommend/Recommend';

const RecommendRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<Recommend />} />
    </Routes>
  );
};

export default RecommendRouter;